module.exports = __webpack_public_path__ + "static/img/blbd-img2.2b776a63.png";